// import axios from 'axios';

// const timestampURL = `${process.env.VUE_APP_INDIGO_API_URL}/api/v1/analytics/time.php`;

const getNumberLength = number => number.toString().length;

const getHitTimestamp = () => {
  const date = new Date();

  const day = getNumberLength(date.getUTCDate()) === 1 ? `0${date.getUTCDate()}` : date.getUTCDate();
  let month = date.getUTCMonth() + 1;
  month = getNumberLength(month) === 1 ? `0${month}` : month;
  const year = date.getUTCFullYear();
  const hour = getNumberLength(date.getUTCHours()) === 1 ? `0${date.getUTCHours()}` : date.getUTCHours();
  const minutes = getNumberLength(date.getUTCMinutes()) === 1 ? `0${date.getUTCMinutes()}` : date.getUTCMinutes();
  const seconds = getNumberLength(date.getUTCSeconds()) === 1 ? `0${date.getUTCSeconds()}` : date.getUTCSeconds();
  const milliseconds = () => {
    if (getNumberLength(date.getUTCMilliseconds()) < 3) {
      return getNumberLength(date.getUTCMilliseconds()) === 1 ? `00${date.getUTCMilliseconds()}` : `0${date.getUTCMilliseconds()}`;
    }
    return date.getUTCMilliseconds();
  };

  return `${day}/${month}/${year} ${hour}:${minutes}:${seconds}:${milliseconds()}`;
}; 

const gaEvent = (category, action, label) => {
  // axios.get(timestampURL).then((time) => {

  // dataLayer.push({
  //   event: 'gtm.event',
  //   eventCategory: emptyString(category),
  //   eventAction: emptyString(action),
  //   eventLabel: emptyString(label),
  //   eventTimeStamp: getHitTimestamp(),
  // });

  // if (process.env.NODE_ENV === 'development') {
  //   console.log({
  //     event: 'gtm.event',
  //     eventCategory: emptyString(category),
  //     eventAction: emptyString(action),
  //     eventLabel: emptyString(label),
  //     eventTimeStamp: getHitTimestamp(),
  //   });
  // }
  // });
};

const gtmPropperConversion = () => {
  // axios.get(timestampURL).then((time) => {
  // dataLayer.push({
  //   event: 'gtm.propper_conversion',
  //   eventTimeStamp: getHitTimestamp(),
  // });

  // if (process.env.NODE_ENV === 'development') {
  //   console.log({
  //     event: 'gtm.propper_conversion',
  //     eventTimeStamp: getHitTimestamp(),
  //   });
  // }
  // });
};

const gaPageView = (value) => {
  // axios.get(timestampURL).then((time) => {
  // dataLayer.push({
  //   event: 'gtm.pageview',
  //   pageview: value,
  //   eventTimeStamp: getHitTimestamp(),
  // });

  // if (process.env.NODE_ENV === 'development') {
  //   console.log({
  //     event: 'gtm.pageview',
  //     pageview: value,
  //     eventTimeStamp: getHitTimestamp(),
  //   });
  // }
  // });
};


// Set a Data Layer Variable
const gaSetVariable = (gaConfig) => {
  // dataLayer.push(gaConfig);
};

const emptyString = (value) => {
  if(value === "")
  {
    return '(not set)';
  }
  return value;
}

export default {
  gaEvent, gaPageView, gaSetVariable, gtmPropperConversion, getHitTimestamp,
};
